import { Input as ChakraInput, InputProps } from '@chakra-ui/input'
import { Box, InputGroup, BoxProps, InputRightElement } from '@chakra-ui/react'
import * as React from 'react'
import { useColor } from '../../../theme'
import { ErrorMessage } from '../ErrorMessage'
import { IFormValidationProps } from '../hooks'

interface IInputProps {
  containerProps?: BoxProps
  rightElement?: React.ReactElement
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  onKeyUp?: React.KeyboardEventHandler<HTMLInputElement>
  inputRightElement?: React.ReactElement
}

export const Input = React.forwardRef<
  HTMLInputElement,
  IFormValidationProps & IInputProps & InputProps
>(
  (
    {
      isInvalid,
      Label,
      errorMessage,
      isDisabled,
      placeholder,
      rightElement,
      containerProps,
      onKeyDown,
      onKeyUp,
      inputRightElement,
      ...rest
    },
    ref,
  ) => {
    const invalidColor = useColor({ nuance: 'red', palette: 'colors' })

    return (
      <Box
        alignContent="start"
        data-testid="input-container"
        display="grid"
        {...containerProps}>
        {Label && <Label />}

        <InputGroup data-testid="input-group">
          <ChakraInput
            backgroundColor="#EDEDF2"
            data-testid="input-field"
            errorBorderColor={invalidColor}
            fontSize="md"
            isDisabled={isDisabled}
            isInvalid={isInvalid}
            onKeyDown={onKeyDown}
            onKeyUp={onKeyUp}
            placeholder={placeholder}
            ref={ref}
            {...rest}
          />

          {inputRightElement && <InputRightElement height="full">
            {inputRightElement}
          </InputRightElement>}

          {rightElement ? rightElement : ''}
        </InputGroup>

        {errorMessage && (
          <ErrorMessage isDisabled={isDisabled}>{errorMessage}</ErrorMessage>
        )}
      </Box>
    )
  },
)
